import Vue from 'vue';
import javascriptBridge from './lib/javascript-bridge';
import linkedme from './lib/linkedme';
import logger from './logger';
import xinstall from './lib/xinstall';
import './sensors';

// 第三方深度链接
Object.defineProperty(Vue.prototype, '$linkedme', {
  value: linkedme,
});

// JavaScript Bridge
Object.defineProperty(Vue.prototype, '$bridge', {
  value: javascriptBridge,
});

// Logger
Object.defineProperty(Vue.prototype, '$logger', {
  value: logger,
});

// xinstall
Object.defineProperty(Vue.prototype, '$xinstall', {
  value: xinstall,
});
